import {
  LuckyDrawRuleModel,
  PrizeRuleDetail,
  TransactionRule,
} from '../../../models/LuckyDraw.model'

export const transformLuckyDrawData = (formData: any, isDraft = false) => ({
  prize_rules: (formData?.prize_rules ?? []).map(
    ({
      merchant_categories,
      merchants,
      prize_transaction_rules,
      ...store
    }: LuckyDrawRuleModel) => ({
      ...store,
      is_draft: isDraft,
      merchant_ids: merchants?.map((m) => m?.id) ?? [],
      merchants:
        merchants?.map((m) => ({
          id: m.id,
          unique_merchant_name: m.unique_merchant_name,
        })) ?? [],
      merchant_category_ids: merchant_categories?.map((c) => c?.id) ?? [],
      prize_transaction_rules: (prize_transaction_rules ?? []).map(
        ({
          payment_categories,
          payment_methods,
          minimum_transaction,
          prizes,
          is_mixable,
          is_multiple_entry,
          min_combine_total_amount,
          max_combine_receipt,
          is_multiplication_combine_receipt,
          is_combine_receipt,
          ...rule
        }: TransactionRule) => {
          const isCombine = Boolean(is_combine_receipt)
          return {
            ...rule,
            is_draft: isDraft,
            is_combine_receipt: isCombine,
            minimum_transaction:
              minimum_transaction !== undefined &&
              minimum_transaction !== null &&
              (minimum_transaction as any) !== ''
                ? +minimum_transaction
                : null,
            is_mixable: is_mixable ?? false,
            is_multiple_entry: isCombine ? false : (is_multiple_entry ?? false),
            is_multiplication_combine_receipt: isCombine
              ? (is_multiplication_combine_receipt ?? false)
              : false,
            max_combine_receipt: isCombine
              ? max_combine_receipt !== undefined &&
                max_combine_receipt !== null &&
                (max_combine_receipt as any) !== ''
                ? +max_combine_receipt
                : null
              : null,
            min_combine_total_amount: isCombine
              ? min_combine_total_amount !== undefined &&
                min_combine_total_amount !== null &&
                (min_combine_total_amount as any) !== ''
                ? +min_combine_total_amount
                : null
              : null,
            prizes: (prizes ?? []).map(({ prizes, ...prize }: PrizeRuleDetail) => ({
              ...prize,
              is_draft: isDraft,
            })),
          }
        }
      ),
    })
  ),
})
